<template>
  <Modal
      no-scroll
      :data-test-id="dataTestId || 'dynamic-modal'"
      :open="message !== null"
      :closable="closable"
      @close="reset"
  >
    <div class="dynamic-modal">
      <div class="dynamic-modal__message">
        <Headline
            v-if="title"
            class="dynamic-modal__title"
        >
          <h1 class="h2 mt-0">
            {{ title }}
          </h1>
        </Headline>
        <p class="dynamic-modal__message">
          {{ message }}
        </p>
      </div>
    </div>

    <template #bottom>
      <Button
          v-for="(callback, index) in callbacks"
          :key="index"
          :data-test-id="callback.dataTestId"
          v-bind="callback.properties || {}"
          @click="callCallback(index)"
      >
        {{ callback.label }}
      </Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/Modals/Modal.vue'
import Button from '@/components/partials/Buttons/Button/Button.vue'
import Headline from '@/components/partials/Headline.vue'
import { useModalStore } from '@/stores/useModalStore'
import { storeToRefs } from 'pinia'

const {callCallback, reset} = useModalStore()
const {dataTestId, message, closable, title, callbacks} = storeToRefs(useModalStore())
</script>

<style lang="scss" scoped>
.dynamic-modal {
  max-width: 26rem;

  &__message {
    font-size: 1rem;
  }
}
</style>
